import type { EditorSDK, Logger } from '@wix/wix-data-client-common-standalone'

export default async ({
  editorSdkProxy,
  logger,
  shouldShowIllustration = true,
  illustration,
  helpId,
  headerText,
  descriptionText,
  mainActionText,
  secondaryActionText,
  onMainActionClick,
  onSecondaryActionClick,
  onCloseClick,
}: {
  editorSdkProxy: EditorSDK
  logger: Logger
  shouldShowIllustration?: boolean
  illustration: string
  helpId?: string
  headerText: string
  descriptionText: string
  mainActionText: string
  secondaryActionText?: string
  onMainActionClick?: () => Promise<void> | void
  onSecondaryActionClick?: () => Promise<void> | void
  onCloseClick?: () => Promise<void> | void
}) => {
  try {
    const panelResult = await editorSdkProxy.editor.openConfirmationPanel({
      shouldShowIllustration,
      illustration,
      helpId,
      headerText,
      descriptionText,
      mainActionText,
      secondaryActionText,
    })

    const actions = {
      mainActionClicked: onMainActionClick,
      secActionClicked: onSecondaryActionClick,
      closeActionClicked: onCloseClick,
    }

    const action = actions[panelResult]

    if (action) {
      await action()
    }
  } catch (error) {
    logger.error(
      new Error('Failed to open confirmation panel', { cause: error }),
    )
  }
}
